<template>
  <select v-else v-model="current_value" class="form-control custom-select">
    <option value="">{{ placeholder }}</option>
    <option
      v-for="opt in options"
      :key="opt._id"
      :value="opt._id"
      v-text="opt.name"
    ></option>
  </select>
</template>

<script>
import {H} from 'hennig-common'
import BaseComponent from './BaseComponent'

export default {
  name: 'PhaseSelect',
  extends: BaseComponent,
  props: {
    value: {},
    init_placeholder: {String, default: '- Selecione uma fase -'},
  },
  data () {
    return {
      placeholder: '',
      current_value: ''
    }
  },
  watch: {
    value (newvalue) {
      this.current_value = newvalue
    },
    current_value (newvalue) {
      this.emitInput(newvalue)
    }
  },
  mounted () {
    this.baseMounted()

    H.rpc('Phase', 'lookup', [''], options => {
      if (options) {
        this.options = options
      }

      this.emitRow(this.current_value)
    })
  }
}
</script>

<style scoped>

</style>
